// removed by extract-text-webpack-plugin
module.exports = {"button":"src-components-Button----button-module---button---1Tg9s"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/button.module.scss
// module id = 338
// module chunks = 168707334958949